module.exports = __webpack_public_path__ + "static/img/mp3.fc92625.png";